import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CotizacionService } from './cotizacion.service';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {



  public cotizacionForm: FormGroup;
  public loadingCotizacion: boolean;

  icons = [
    {
      'img': 'crp.svg',
      'name': 'Primeros auxilios'
    },
    {
      'img': 'first-aid.svg',
      'name': 'Medical kit'
    },
    {
      'img': 'fire.svg',
      'name': 'Emergencias'
    },

  ];

  constructor(private cotizacionService: CotizacionService) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.cotizacionForm = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      establecimiento: new FormControl('', [Validators.required]),
      telefono: new FormControl('', [Validators.required]),
      detalle: new FormControl('', [Validators.required]),

    });
  }


sendForm() {
  this.loadingCotizacion = true;
  this.cotizacionService.sendForm(this.cotizacionForm.value).subscribe(
    (res: any) => {
      this.loadingCotizacion = false;
      alert('Mensaje enviado');
      window.location.reload();
    },
    (err) => {
      console.log(err);
      this.loadingCotizacion = false;
    }
  );
}



}
